import {
  GSItemInfo
} from "golfstatus_react_components";

export function getNotificationItemInfo(value, icon, header=null, description=null){
  return <GSItemInfo value={value} header={header} description={description} icon={icon}></GSItemInfo>
}